import sinaIdle from '../../assets/sina_neutral.png';
import sinaHelp from '../../assets/sina_explicando.png';
import sinaThinking from '../../assets/sina_pensando.png';
import sinaSuccess from '../../assets/sina_exito.png';
import sinaWarning from '../../assets/sina_advertencia.png';
import sinaError from '../../assets/sina_aviso_importante.png';
import sinaEyesClosed from '../../assets/sina_ojos_cerrados.png';
import sinaLookLeft from '../../assets/sina_mira_izquierda.png';
import sinaLookRight from '../../assets/sina_mira_derecha.png';

// Frames de la cara en reposo para animar ojos; comparten silueta con `idle`.
export const SINA_IDLE_FRAMES = Object.freeze({
  blink: sinaEyesClosed,
  lookLeft: sinaLookLeft,
  lookRight: sinaLookRight,
});

// Catálogo único para el asistente y los avisos operativos.
export const SINA_STATES = Object.freeze({
  idle: { image: sinaIdle, label: 'Sina' },
  help: { image: sinaHelp, label: 'Ayuda' },
  thinking: { image: sinaThinking, label: 'Analizando' },
  success: { image: sinaSuccess, label: 'Operación completada' },
  warning: { image: sinaWarning, label: 'Atención' },
  error: { image: sinaError, label: 'Ocurrió un problema' },
});

export function getSinaState(state = 'idle') {
  return SINA_STATES[state] || SINA_STATES.idle;
}
